<template>
    <div>
        <Headers :title="title"></Headers>
        <div class="banner" >
            <div class="info-wrap" v-if="userInfo.id">
                <p class="photo-wrap"><img class="profile-photo" :src="require('@/assets/user/avatar.png')" alt=""></p>
                <p class="user-name">{{ userInfo.real_name || "" }}</p>
            </div>
            <div class="info-wrap" v-else>
                <p class="photo-wrap"><img class="profile-photo" alt=""></p>
                <p class="user-name"  @click="toLogin">{{ $t('exhibit').login}}</p>
            </div>
        </div>
        <div class="tab-wrap">
            <div class="tab-item" @click="toMyCollection" v-if="userInfo.id">
                <p class="icon-wrap icon-store">
                    <img src="~statics/store.png" alt="">
                </p>
                <p>{{$t('areaIndex').scj}}</p>
            </div>
            <div class="tab-item" @click="toMyCardHolder" v-if="userInfo.id"> 
                <p class="icon-wrap icon-card">
                   <img src="~statics/card.png" alt="">
                <p>{{$t('areaIndex').mpj}}</p>
            </div>
        </div>
        <div class="list-wrap">
            <div class="item" @click="toMyCard" v-if="userInfo.id"> 
                <p>{{$t('userCenter').cardTitle}}</p>
                <van-icon name="arrow" />
            </div>
            <div class="item" @click="toPersonalInfo" v-if="userInfo.id">
                <p>{{$t('userCenter').baseInfo}}</p>
                <van-icon name="arrow" />
            </div>
            <div class="item" @click="toPasswordModify" v-if="userInfo.id">
                <p>{{$t('userCenter').modifyPsw}}</p>
                <van-icon name="arrow" />
            </div>
        </div>
        <div class="logout item" @click="handleLogout" v-if="userInfo.id">
            <p>{{$t('userCenter').logout}}</p>
            <van-icon name="arrow" />
        </div>
        <Footers></Footers>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";
import api from "@/api";


export default {
    name: 'home',
    data() {
        return {
            showCollpase: true
            // username: sessionStorage.getItem('username')
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        token(){

        },
        title(){
            return  this.language == 'zh' ?  '个人中心' : 'Personal center'
        },
        ...mapState(["userInfo","language","showUserModal"]),
    },
    mounted(){
        this.getMyCard()
        this.$store.dispatch("getUserInfo");
        // console.log(this.userInfo);
    },
    methods: {
        toMyCollection() {
            if(this.userInfo.id){
                this.$router.push({ path: '/collection' })
            }else{
                this.$router.push({path: '/mobileLogin'})
            }
        },
        toMyCardHolder() {
            if(this.userInfo.id){
                this.$router.push({ path: '/cardHolder' })
            }else{
                this.$router.push({path: '/mobileLogin'})
            }
        },
        toMyCard() {
            if(this.userInfo.id){
                this.$router.push({ path: '/MyCard' })
            }else{
                this.$router.push({path: '/mobileLogin'})
            }
        },
        toPersonalInfo() {
            if(this.userInfo.id){
                this.$router.push({ path: '/personalInfo' })
            }else{
                this.$router.push({path: '/mobileLogin'})
            }
        },
        toPasswordModify(){
            if(this.userInfo.id){
                this.$router.push({ path: '/passwordModify' })
            }else{
                this.$router.push({path: '/mobileLogin'})
            }
        },
        getMyCard() {
            api.getMyCard().then((res) => {
                if (res.res === 1) {
                    this.id = res.card.id;
                    this.post = res.card.post;
                    this.company_name = res.card.company_name
                    this.email = res.card.email
                    this.phone = res.card.phone
                    this.cardUrl = res.card.card_image ? res.card.card_image.url : "";
                }
            });
        },
        handleLogout() {
            this.$confirm(this.$t('login').confirm_logout, this.$t('login').tip, {
                confirmButtonText: this.$t('login').confirm,
                cancelButtonText: this.$t('login').cancel,
                type: 'warning',
                customClass: 'confirmBox',
                closeOnClickModal: false
            }).then(() => {
                this.$notify({ type: 'success', message: this.$t('login').login_out });
                // this.$notify(this.$t('login').login_out);
                setTimeout(()=>{
                    this.handleClose();
                    window.logout();
                },500)
            }).catch(() => {})
        },
        handleClose() {
            this.showCollpase = false;
        },
        toLogin(){
            if (!this.userInfo.id) {
                this.$router.push({ path: '/mobileLogin' })
            } else{
                this.showCollpase = true
            }
            
        }
    },
    components: {
        Footers,
        Headers
    }
}
</script>

<style lang="scss" scoped>
.banner{
    height: 4rem;
    // background: linear-gradient(153deg, #52B4DD 0%, #246DA8 100%);
    background: #194b96;
    border-radius: 0px 0px .64rem .64rem;
    padding-top: .98rem;
    box-sizing: border-box;
    .info-wrap{
        display: flex;
        align-items: center;
        margin: 0 0 0 .5rem;
        .photo-wrap{
            margin: 0 .3rem 0 0;
            width: 1.4rem;
            height: 1.4rem;
            border: 1px solid #fff;
            border-radius: 100%;
            .profile-photo{
                width: 100%;
                height: 100%;
                border-radius: 100%;
            }
        }
        .user-name{
            color: #fff;
            font-size: .4rem;
        }
    }
}

.tab-wrap{
    display: flex;
    width: 7rem;
    height: 1.66rem;
    padding: .3rem .5rem .28rem .5rem;
    box-sizing: border-box;
    border-radius: .08rem;
    background-color: #fff;
    margin: -.96rem auto .2rem;
    .tab-item{
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ddd;
        font-size: .36rem;
        &:last-child{
            border: 0
        }
        .icon-wrap{
            width: .7rem;
            height: .7rem;
            line-height: .7rem;
            text-align: center;
            margin-bottom: .08rem;
            color: #fff;
            border-radius: 100%;
            img{
                width: 100% ;
                height: 100%;
            }
        }
    }
}
.list-wrap{
    width: 7rem;
    height: auto;
    box-sizing: border-box;
    background-color: #fff;
    padding-left: .3rem;
    border-radius: .08rem;
    margin: 0 auto;
    .item{
        display: flex;
        justify-content: space-between;
        padding: .38rem .3rem .4rem 0;
        border-bottom: 1px solid #c4c4c4;
        font-size: .36rem;
        &:last-child{
             border: 0
        }
    }
}
.logout{
    width: 7rem;
    margin: 0 auto .8rem;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: .08rem;
    margin-top: .2rem;
    display: flex;
    justify-content: space-between;
    font-size: .36rem;
    &.item{
        padding: .38rem .3rem .4rem .3rem
    }
}
   
    
</style>
<style lang="scss">
.el-message-box__wrapper{
    &::after{
        content: "";
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle !important;
    }   
    .confirmBox{
        width: 6rem !important
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/home.vue